import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';

import {
  GQLAccessoryAsset,
  GQLAccessoryAssetInput,
  GQLAccessoryType,
  GQLParty
} from '@jewelutions/core-crm-server-api-client-domain';

import { JwlCheckbox, JwlField, JwlSelect } from '../../../../components';
import { SelectOption } from '../../../../components/JwlSelect/JwlSelect';

import { stringListToDisplayValueList } from '../../../../core/utils';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ErrorMessage } from '../../../../types-hack';

interface IProps {
  party: GQLParty;
  accessory: GQLAccessoryAsset;
  onClose: (success: boolean) => void;
}

const availableAccessoryTypes: SelectOption[] = stringListToDisplayValueList(Object.keys(GQLAccessoryType));

const CreateOrUpdateAccessoryDialog: React.FC<IProps> = ({ accessory, party, onClose }) => {
  const [saveAccessory, { error, loading }] = GQLOperationBuilder.accessory.updateAccessory();

  const initialValues = {
    public: accessory.public,
    title: accessory.accessory.title.en,
    description: accessory.accessory.description.en,
    type: accessory.accessory.type
  };

  const onSubmit = (props: any) => {
    const input: GQLAccessoryAssetInput = {
      description: { en: props.description },
      title: { en: props.title },
      type: props.type,
      ownerPartyId: party.id,
      public: true
    };

    const mutationVariables = { input: input, accessoryId: accessory.id };
    saveAccessory({ variables: mutationVariables }).then(_result => onClose(true));
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string().required('Description is required'),
    title: Yup.string().required('Title is required')
  });
  return (
    <Dialog open maxWidth="md" aria-labelledby="create-update-accessory">
      <DialogTitle>{`Update accessory`}</DialogTitle>
      <DialogContent className="w-dialog-small">
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ values, handleSubmit }) => (
            <form onSubmit={handleSubmit} className="flex flex-col">
              <Field name={`title`} component={JwlField} label="Title" />
              <ErrorMessage component="span" name={`title`} className="fs-12 text-error" />

              <Field name={`description`} component={JwlField} label="Description" />
              <ErrorMessage component="span" name="description" className="fs-12 text-error" />

              <Field
                name="type"
                component={JwlSelect}
                label="Accessory Type"
                options={availableAccessoryTypes}
              />

              <Field name="public" component={JwlCheckbox} label="Public" />

              <DialogActions>
                <Button color="primary" onClick={() => onClose(false)}>
                  Close
                </Button>
                <Button type="submit" color="primary" variant="contained">
                  Save
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default CreateOrUpdateAccessoryDialog;
